"use client";

import { ReactNode, Suspense } from "react";
import { NextIntlClientProvider } from "next-intl";
import { GoogleOAuthProvider } from "@react-oauth/google";

import { AuthProvider } from "@/app/components/providers/AuthProvider";
import { ThemeProvider } from "@/app/components/providers/theme-provider";
import { Toaster, Loading, Header } from "@/app/components/ui";

type MessageType = {
   [key: string]: string | MessageType;
};

type ClientLayoutProps = {
   children: ReactNode;
   locale: string;
   messages: MessageType;
};

export default function ClientLayout({ children, locale, messages }: ClientLayoutProps) {
   const googleClientId = process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID;
   return (
      <Suspense fallback={<Loading />}>
         <NextIntlClientProvider
            locale={locale}
            messages={messages}
            timeZone="Asia/Saigon"
         >
            <GoogleOAuthProvider clientId={googleClientId || ""}>
               <ThemeProvider>
                  <AuthProvider>
                     <div suppressHydrationWarning>
                        <Header />
                        {children}
                        <Toaster />
                     </div>
                  </AuthProvider>
               </ThemeProvider>
            </GoogleOAuthProvider>
         </NextIntlClientProvider>
      </Suspense>
   );
}
